module.exports = __webpack_public_path__ + "孙宇晨-2d42eb5e.png";